<template>
  <div ref="agTagsContainer" class="tags-group-container" :class="{ 'tags-group-container--has-tags': hasTags }">
    <AGTag
      v-for="(tag, index) in splicedTags"
      :key="tag.label"
      :ref="'agTagGroupItem' + index"
      :label="tag.label"
      :max-character="maxcMaracter"
      :close="tag.close === undefined ? true : tag.close"
      :outlined="outlined"
      :type="tag.type"
      @click="onClick(tag)"
      @click:close="onClose(tag)"
    />
    <AGTag
      v-if="showMoreButton"
      ref="showMoreButtonTag"
      class="tags-group-container__counter"
      outlined
      :label="tagsCounterLabel"
      @click="isExpanded = !isExpanded"
    />
  </div>
</template>

<script>
import AGTag from '@/components/common/AGTag.vue';

export default {
  components: { AGTag },
  props: {
    tags: {
      type: Array,
      default: () => [],
    },

    maxcMaracter: {
      type: Number,
      default: 64,
    },

    outlined: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isExpanded: false,
      showMoreButton: false,
      visibleTags: 0,
      isCalculated: false,
    };
  },

  computed: {
    tagsCounter() {
      return this.tags.length - this.visibleTags;
    },

    hasTags() {
      return this.tags.length > 0;
    },

    tagsCounterLabel() {
      if (this.isExpanded) return 'Ver menos';
      if (this.tagsCounter <= 99) return `+${this.tagsCounter}`;
      return '99+';
    },

    splicedTags() {
      return this.isExpanded || !this.isCalculated ? this.tags : this.tags.slice(0, this.visibleTags);
    },
  },

  watch: {
    tags: {
      handler() {
        this.checkTagsWidth();
      },

      deep: true,
      immediate: true,
    },
  },

  methods: {
    checkTagsWidth() {
      this.isCalculated = false;
      this.$nextTick(() => {
        const containerWidth = this.$refs.agTagsContainer?.offsetWidth;
        const children = this.$refs.agTagsContainer?.children;
        const showMoreButtonWidth = this.$refs.showMoreButtonTag?.offsetWidth || 32;
        let totalWidth = 0;

        for (let i = 0; i < children.length; i++) {
          totalWidth += children[i].offsetWidth + 16;

          if (totalWidth + showMoreButtonWidth > containerWidth) {
            if (this.showMoreButton === false) this.isExpanded = false;
            this.showMoreButton = true;
            this.visibleTags = i;
            this.isCalculated = true;
            return;
          }
        }

        this.showMoreButton = false;
        this.visibleTags = children.length;
        this.isCalculated = true;
      });
    },

    onClick(tag) {
      if (tag.onClick) tag.onClick();
    },

    onClose(tag) {
      if (tag.onClose) tag.onClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.tags-group-container {
  display: flex;
  gap: 8px 16px;
  justify-content: flex-end;
  flex-wrap: wrap;
  flex: 1;
  overflow: hidden;

  &.tags-group-container--has-tags {
    margin-top: $spacing-05;
  }

  .tags-group-container__counter {
    background-color: $neutral-color-low-light !important;
    color: $brand-color-primary-dark !important;
    border-color: $brand-color-primary-medium !important;
    transition:
      background-color 150ms ease,
      border-color 150ms ease;
    &:hover {
      background-color: $brand-color-highlight-light !important;
      border-color: $brand-color-highlight-light !important;
    }
  }
}
</style>
